var _path, _path2, _path3, _path4, _path5, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8857 19.0642C13.8857 18.6027 14.2599 18.2285 14.7215 18.2285H18.0643C18.5259 18.2285 18.9 18.6027 18.9 19.0642C18.9 19.5258 18.5259 19.8999 18.0643 19.8999H14.7215C14.2599 19.8999 13.8857 19.5258 13.8857 19.0642Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8857 32.4358C13.8857 31.9743 14.2599 31.6001 14.7215 31.6001H18.0643C18.5259 31.6001 18.9 31.9743 18.9 32.4358C18.9 32.8974 18.5259 33.2715 18.0643 33.2715H14.7215C14.2599 33.2715 13.8857 32.8974 13.8857 32.4358Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1428 19.0642C27.1428 18.6027 27.517 18.2285 27.9785 18.2285L35.7785 18.2285C36.2401 18.2285 36.6142 18.6027 36.6142 19.0642C36.6142 19.5258 36.2401 19.8999 35.7785 19.8999L27.9785 19.8999C27.517 19.8999 27.1428 19.5258 27.1428 19.0642Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1428 32.4358C27.1428 31.9743 27.517 31.6001 27.9785 31.6001L35.7785 31.6001C36.2401 31.6001 36.6142 31.9743 36.6142 32.4358C36.6142 32.8974 36.2401 33.2715 35.7785 33.2715L27.9785 33.2715C27.517 33.2715 27.1428 32.8974 27.1428 32.4358Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8857 25.7498C13.8857 25.2882 14.2599 24.9141 14.7215 24.9141H28.0929C28.5544 24.9141 28.9286 25.2882 28.9286 25.7498C28.9286 26.2113 28.5544 26.5855 28.0929 26.5855H14.7215C14.2599 26.5855 13.8857 26.2113 13.8857 25.7498Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4534_13405)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 18.5071C20 17.1225 21.1225 16 22.5071 16H23.6214C25.0061 16 26.1286 17.1225 26.1286 18.5071V19.6214C26.1286 21.0061 25.0061 22.1286 23.6214 22.1286H22.5071C21.1225 22.1286 20 21.0061 20 19.6214V18.5071ZM22.5071 17.6714C22.0456 17.6714 21.6714 18.0456 21.6714 18.5071V19.6214C21.6714 20.083 22.0456 20.4571 22.5071 20.4571H23.6214C24.083 20.4571 24.4571 20.083 24.4571 19.6214V18.5071C24.4571 18.0456 24.083 17.6714 23.6214 17.6714H22.5071Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4534_13405)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 31.8787C20 30.4941 21.1225 29.3716 22.5071 29.3716H23.6214C25.0061 29.3716 26.1286 30.4941 26.1286 31.8787V32.993C26.1286 34.3777 25.0061 35.5002 23.6214 35.5002H22.5071C21.1225 35.5002 20 34.3777 20 32.993V31.8787ZM22.5071 31.043C22.0456 31.043 21.6714 31.4172 21.6714 31.8787V32.993C21.6714 33.4546 22.0456 33.8287 22.5071 33.8287H23.6214C24.083 33.8287 24.4571 33.4546 24.4571 32.993V31.8787C24.4571 31.4172 24.083 31.043 23.6214 31.043H22.5071Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4534_13405)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0286 25.1927C30.0286 23.808 31.1511 22.6855 32.5357 22.6855H33.65C35.0346 22.6855 36.1571 23.808 36.1571 25.1927V26.307C36.1571 27.6916 35.0346 28.8141 33.65 28.8141H32.5357C31.1511 28.8141 30.0286 27.6916 30.0286 26.307V25.1927ZM32.5357 24.357C32.0742 24.357 31.7 24.7311 31.7 25.1927V26.307C31.7 26.7685 32.0742 27.1427 32.5357 27.1427H33.65C34.1115 27.1427 34.4857 26.7685 34.4857 26.307V25.1927C34.4857 24.7311 34.1115 24.357 33.65 24.357H32.5357Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4534_13405",
    x: 18,
    y: 15,
    width: 10.1285,
    height: 10.1284,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4534_13405"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4534_13405",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4534_13405",
    x: 18,
    y: 28.3716,
    width: 10.1285,
    height: 10.1284,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4534_13405"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4534_13405",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4534_13405",
    x: 28.0286,
    y: 21.6855,
    width: 10.1285,
    height: 10.1284,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4534_13405"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4534_13405",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.bed1a8c6ed8982d30cba3acb62ed4718.svg";
export { ForwardRef as ReactComponent };